import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';
import { CreditRegisterModalModule } from './modals/credit-register-modal.module';

import { CreditRegisterComponent } from './credit-register.component';

@NgModule({
  declarations: [
    CreditRegisterComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ComponentsModule,
    B3DesignSystemWebModule,
    CreditRegisterModalModule,
  ],
  exports: [
    CreditRegisterComponent,
  ],
  providers: [
    DatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreditRegisterModule { }
